export const menuLists = [
  {
    title: "Home",
    url: "/home",
  },
  {
    title: "Gallery",
    url: "/gallery",
  },
  // {
  //   title: "News",
  //   url: "/news",
  // },
  {
    title: "Committee",
    url: "/members",
  },
  {
    title: "JOIN",
    url: "/join",
  },
];
